const SORT_ORDER_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
}

const SORT_ORDER = {
  CREATED_AT: 'created_at',
  PAYMENT_AMOUNT: 'amount',
}

const FILTER_TYPE_STATUS = {
  ALL: 'all',
  WAITING_FOR_DEPOSIT: 'waiting_for_deposit',
  PARTIAlLY_PAID: 'partially_paid',
  PAYMENT_ACCEPTED: 'payment_accepted',
  FINISHED: 'finished',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
  NOT_INVITED: 'not_invited',
  PAYS_ERROR: 'pays_error',
  PAID: 'paid',
  RAW_ERROR: 'raw_error',
  INVITED: 'invited',
  IN_EMCD: 'in_emcd',
  APPROVED: 'approved',
}

const PAYMENT_STATUS_TYPE = {
  ALL: 'all',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  AML_DECLINED: 'aml_declined',
}

const SORT = [
  {
    optionLabel: 'PaymentHistoryTable | sort | title.created_at',
    optionDescription:
      'PaymentLinksHistoryTable | sort | description | title.created_at',
    value: {
      sort_by: SORT_ORDER.CREATED_AT,
      sort_direction: SORT_ORDER_DIRECTION.DESC,
    },
    optionValue: JSON.stringify({
      sort_by: SORT_ORDER.CREATED_AT,
      sort_direction: SORT_ORDER_DIRECTION.DESC,
    }),
  },
  {
    optionLabel: 'PaymentHistoryTable | sort | title.amount',
    optionDescription:
      'PaymentLinksHistoryTable | sort | description | title.amount',
    value: {
      sort_by: SORT_ORDER.PAYMENT_AMOUNT,
      sort_direction: SORT_ORDER_DIRECTION.DESC,
    },
    optionValue: JSON.stringify({
      sort_by: SORT_ORDER.PAYMENT_AMOUNT,
      sort_direction: SORT_ORDER_DIRECTION.DESC,
    }),
  },
]

const FILTERS = [
  {
    optionLabel: 'PaymentHistoryTable | filter | status.all',
    value: '[]',
    optionValue: '[]',
  },
  {
    optionLabel: 'PaymentHistoryTable | filter | status.active',
    value: JSON.stringify([FILTER_TYPE_STATUS.ACTIVE]),
    optionValue: JSON.stringify([FILTER_TYPE_STATUS.ACTIVE]),
  },
  {
    optionLabel: 'PaymentHistoryTable | filter | status.paused',
    value: JSON.stringify([FILTER_TYPE_STATUS.PAUSED]),
    optionValue: JSON.stringify([FILTER_TYPE_STATUS.PAUSED]),
  },
  {
    optionLabel: 'PaymentHistoryTable | filter | status.expired',
    value: JSON.stringify([FILTER_TYPE_STATUS.EXPIRED]),
    optionValue: JSON.stringify([FILTER_TYPE_STATUS.EXPIRED]),
  },
]

const PAYMENT_STATUS_FILTERS = [
  {
    optionLabel: 'PaymentHistoryTable | filter | paymentStatus.all',
    value: '[]',
    optionValue: '[]',
  },
  {
    optionLabel: 'PaymentHistoryTable | filter | paymentStatus.pending',
    value: JSON.stringify([PAYMENT_STATUS_TYPE.PENDING]),
    optionValue: JSON.stringify([PAYMENT_STATUS_TYPE.PENDING]),
  },
  {
    optionLabel: 'PaymentHistoryTable | filter | paymentStatus.success',
    value: JSON.stringify([PAYMENT_STATUS_TYPE.SUCCESS]),
    optionValue: JSON.stringify([PAYMENT_STATUS_TYPE.SUCCESS]),
  },
  {
    optionLabel: 'PaymentHistoryTable | filter | paymentStatus.aml_declined',
    value: JSON.stringify([PAYMENT_STATUS_TYPE.AML_DECLINED]),
    optionValue: JSON.stringify([PAYMENT_STATUS_TYPE.AML_DECLINED]),
  },
]

export {
  SORT,
  FILTERS,
  FILTER_TYPE_STATUS,
  PAYMENT_STATUS_FILTERS,
  PAYMENT_STATUS_TYPE,
}
